import React from 'react';

import ReadMoreLink from '../ReadMoreLink';

import classNames from 'classnames/bind';
import style from './CallToAction.scss';
const ctx = classNames.bind(style);

const CallToAction = props => (
  <div className={ctx('call-to-action')}>
    <ReadMoreLink
      title={'ПЕРЕЙТИ И КУПИТЬ'}
      link={'https://matchpointhouse.ru/'}
      style={{ backgroundColor: '#ECB84C' }}
    />
  </div>
);

export default CallToAction;
